import api from "@/lib/api";

export const MAX_VIDEO_MB = 25;

export function isVideoSrc(src) {
  if (!src) return false;
  return src.startsWith("data:video") || /\.(mp4|webm|mov|ogg)(\?|$)/i.test(src);
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function compressImage(file, maxWidth = 1400, quality = 0.85) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxWidth / img.width);
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Prepares an image or video file for storage. Videos are compressed server-side
// (H.264, max 1280px, no audio) so they load fast on mobile.
export async function prepareMediaFile(file) {
  if (file.type.startsWith("video/")) {
    if (file.size > MAX_VIDEO_MB * 1024 * 1024) {
      throw new Error(`El video es muy grande (máx. ${MAX_VIDEO_MB} MB). Elige uno más corto o de menor calidad.`);
    }
    const raw = await readFileAsDataUrl(file);
    const res = await api.post("/media/optimize", { data_url: raw });
    return { dataUrl: res.data.data_url, mediaType: "video" };
  }
  const dataUrl = await compressImage(file);
  return { dataUrl, mediaType: "image" };
}
